/**
 * Bordures configurables des box (Volet, Carte info…) : radius + côtés
 * affichés + couleur — remplace les anciens « styles » figés. Résolution
 * CSS côté rendu (viewer-safe, aucune dépendance éditeur).
 */

/** Gris Mantine gray-3 — trait par défaut (équivalent Paper withBorder). */
export const DEFAULT_BORDER_COLOR = '#dee2e6';

/** Défaut : angles arrondis (8 px), les 4 bordures affichées. */
export const DEFAULT_BORDER = {
  radius: '0.5rem',
  color: '',
  top: true,
  right: true,
  bottom: true,
  left: true,
};

/**
 * Défaut des blocs dont le rendu d'origine n'a pas de cadre (Liste de badges,
 * Frise…) : bordures réglables, mais aucun trait affiché tant que
 * l'utilisateur n'en allume pas un.
 */
export const BORDERLESS_BORDER = {
  ...DEFAULT_BORDER,
  top: false,
  right: false,
  bottom: false,
  left: false,
};

/** Props border (partiel/absent toléré) → styles CSS React. */
export function borderCssFromProps(border) {
  const b = { ...DEFAULT_BORDER, ...(border || {}) };
  const line = `1px solid ${b.color || DEFAULT_BORDER_COLOR}`;
  return {
    borderRadius: b.radius === '' || b.radius == null ? 0 : b.radius,
    borderTop: b.top ? line : 'none',
    borderRight: b.right ? line : 'none',
    borderBottom: b.bottom ? line : 'none',
    borderLeft: b.left ? line : 'none',
  };
}
